/** Preserve an observed detail URL; never turn a source homepage into event details. */
export function aiEventDetailsUrl(sourceUrl: string, sourceURLs: string[] = []): string {
  return (
    [sourceUrl, ...sourceURLs].find((value) => {
      try {
        const url = new URL(value);
        return (
          ["https:", "http:"].includes(url.protocol) &&
          !url.username &&
          !url.password &&
          (url.pathname !== "/" || url.search.length > 0)
        );
      } catch {
        return false;
      }
    }) ?? ""
  );
}
